<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" header="Cierre perdido" [style]="{ width: '480px' }" (onHide)="close()">
  <div *ngIf="!canClose" class="provisional-banner">
    <i class="pi pi-info-circle"></i>
    <span>El cliente ya está en originación o convertido. El cierre ganado/perdido se gestiona desde el flujo del arrendamiento.</span>
  </div>

  <form *ngIf="canClose" [formGroup]="form" (ngSubmit)="submit()" class="form-stack">
    <div class="field field-flex">
      <label for="reason">*Causa de la pérdida:</label>
      <p-dropdown inputId="reason" formControlName="reason" [options]="reasons" optionLabel="label" optionValue="value" placeholder="Seleccionar causa" appendTo="body" [style]="{ width: '100%' }"></p-dropdown>
    </div>
    <div class="form-action">
      <button pButton type="submit" label="Marcar como perdido" icon="pi pi-flag" class="p-button-danger" [disabled]="form.invalid" [style.width]="'100%'"></button>
    </div>
  </form>
</p-dialog>
<p-toast position="top-right"></p-toast>
